// extracted by mini-css-extract-plugin
export var Inline = "styles-module--Inline--3aQug";
export var Message = "styles-module--Message--2gYjP";
export var Page = "styles-module--Page--2haiR";